import { lazy } from 'react'

export const BannerPage = lazy(() => import('./Banner'))
export const LogoPage = lazy(() => import('./Logo'))
export const PopupPage = lazy(() =>import('./Popup'))